import React, { useState } from "react";
import PropTypes from "prop-types";
import { useResize } from "../../utils/resize";
import Image from "../../elements/image";
import PriceDiscount from "../../elements/price-discount";
import styles from "./style.scss";
import { canUseDOM } from "../../utils";
const isSSR = canUseDOM() ? false : true;

const ProductDetailHero = ({
  productHeroImage,
  productName,
  productBrand,
  productDescription,
  priceFormatted,
  discountedPriceFormatted,
  imageTranslation
}) => {
  const [isDesktopMediaQuery, setIsDesktopMediaQuery] = useState(
    !isSSR ? window.matchMedia(styles.mediaQueryDesktop).matches : undefined
  );
  const [isTabletMediaQuery, setIsTabletMediaQuery] = useState(
    !isSSR ? window.matchMedia(styles.mediaQueryTablet).matches : undefined
  );

  useResize(() => {
    setIsDesktopMediaQuery(window.matchMedia(styles.mediaQueryDesktop).matches);
  }, [isDesktopMediaQuery]);
  useResize(() => {
    setIsTabletMediaQuery(window.matchMedia(styles.mediaQueryTablet).matches);
  }, [isTabletMediaQuery]);

  const imageTranslationStyles = {
    vertical: isDesktopMediaQuery
      ? imageTranslation.percentY.l
      : isTabletMediaQuery
      ? imageTranslation.percentY.m
      : imageTranslation.percentY.s,
    horizontal: isDesktopMediaQuery
      ? imageTranslation.percentX.l
      : isTabletMediaQuery
      ? imageTranslation.percentX.m
      : imageTranslation.percentX.s
  };

  return (
    <div className={"prod-detail-hero"}>
      <Image
        {...productHeroImage}
        className={"prod-detail-hero__image"}
        styles={{
          transform: `translate3d(${imageTranslationStyles.horizontal}%, ${imageTranslationStyles.vertical}%, 0)`
        }}
      />
      <div className="prod-detail-hero__inner">
        <div className="grid">
          <div className="prod-detail-hero__content">
            <span className="prod-detail-hero__brand">{productBrand}</span>
            <h1 className="prod-detail-hero__name">{productName}</h1>
            <div className="prod-detail-hero__info-container">
              <p className="prod-detail-hero__description">
                {productDescription}
              </p>
              <div className="product-detail-hero__price-container">
                <PriceDiscount
                  price={priceFormatted}
                  discountPrice={discountedPriceFormatted}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductDetailHero.propTypes = {
  productHeroImage: PropTypes.object,
  productName: PropTypes.string,
  productBrand: PropTypes.string,
  productDescription: PropTypes.string,
  priceFormatted: PropTypes.string,
  discountedPriceFormatted: PropTypes.string,
  imageTranslation: PropTypes.shape({
    percentY: {
      s: PropTypes.number,
      m: PropTypes.number,
      l: PropTypes.number
    },
    percentX: {
      s: PropTypes.number,
      m: PropTypes.number,
      l: PropTypes.number
    }
  })
};

ProductDetailHero.defaultProps = {
  imageTranslation: {
    percentY: {
      s: 0,
      m: 0,
      l: 0
    },
    percentX: {
      s: 0,
      m: 0,
      l: 0
    }
  }
};

export default ProductDetailHero;
